import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "fz-2" }
const _hoisted_3 = { class: "p-5 d-flex justify-content-center w-100" }
const _hoisted_4 = ["src"]

import { translation } from '../../../lang/Translation';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoDataSection',
  setup(__props) {
const t = translation;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t).to("BLOCKVROCKへようこそ！ 🎉🎉🎉 はじめは「あたらしくつくる」ボタンをクリックしてプロジェクトを作りましょう。","welcome")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: '/public/logo.png',
        height: "200",
        width: "400",
        class: "my-4 img-fluid w-50"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})